import { GroupStatusEvent, PinnedMessage, PServed, useIM } from '@wui/im'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import { useNotification } from '@/shared/composables/use-notification'
import { pServedIsRoom } from '@/shared/utils/uri'

export const usePinEventsStore = defineStore('pin-events', () => {
  const { onConferenceUpdated, onPinMessage, onUnpinMessage } = useIM()

  const pinEventsByPServed = ref(new Map<PServed, PinnedMessage[]>())

  const getPinEventsForRoom = (pServed: PServed) => {
    return pinEventsByPServed.value.get(pServed)
  }

  const setPinnedMessages = (pServed: PServed, messages: PinnedMessage[]) => {
    pinEventsByPServed.value.set(pServed, messages)
  }

  onConferenceUpdated((event: GroupStatusEvent) => {
    if (pServedIsRoom(event.pServed) && event.extendedParams.isEnabled === false) {
      return
    }
    const pins = event.extendedParams.pinnedMessages ? [...event.extendedParams.pinnedMessages.map((m) => ({ ...m, extendedParams: { ...m.extendedParams }}))] : []
    setPinnedMessages(event.pServed, pins)
  })

  onPinMessage((event) => {
    useNotification().createPinMessageNotification(event)
  })

  onUnpinMessage((event) => {
    useNotification().createPinMessageNotification(event)
  })

  return {
    pinEvents: pinEventsByPServed,
    getPinEventsForRoom,
    setPinnedMessages,
  }
})
